import { gate } from 'hub-http/gates';
export const PRE_APPROVED = 'Payments:Pay040PreApprovedEnrollment';
export const KYC_EMBEDDED_FALLBACK_EXPERIENCE = gate('Payments:StripeEmbeddedOnboardingFallback');
export const PRODUCT_BUILDER = gate('commerce:product:product-builder');
export const CPQ_QUOTES_GATE = gate('commerce:cpq:bse:CPQQuote');
export const CPQ_UPGRADES_GATE = gate('commerce:cpq:upgrades');
export const ACTIVE_CQT_PORTAL = gate('commerce:cpq:ActiveCQTQuotesPortals');
export const NEW_PORTAL_CPQ_EXPERIENCE = gate('commerce:cpq:newPortalCPQExperience');
export const PRODUCT_BUILDER_IFRAME_GATE = gate('commerce:products:productCreatorIFrame');
export const QUOTES_STATUS_DEALS_INDEX = gate('commerce:cpq:QuotesStatusDealsIndex');
export const LEGACY_QUOTES_ACCESS_UPDATE = gate('commerce:cpq:legacyQuotesAccessUpdate');